import type {
  DeviceViewElementType,
  DeviceViewEntityId,
} from 'components/DeviceView/deviceViewTypes';
import {
  type DeviceViewCommandFactory,
  createInitialDeviceViewState,
} from '../DeviceViewModel';
import { getNewActiveEntityId } from '../helpers/getNewActiveEntityId';

interface CloseDeviceViewEntityCommand {
  deviceViewElement?: DeviceViewElementType;
  deviceViewEntityId: DeviceViewEntityId | undefined;
}

export const closeDeviceViewEntity: DeviceViewCommandFactory<
  CloseDeviceViewEntityCommand
> = (cmdContext) => (command) => {
  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
  cmdContext.updateState((draft) => {
    if (
      command.deviceViewEntityId === undefined ||
      draft.deviceViewEntities.length === 1
    ) {
      cmdContext.getState().handlersContainer.handleCloseDeviceExplorer?.();
      return createInitialDeviceViewState();
    }
    draft.deviceViewEntities = draft.deviceViewEntities.filter(
      (entity) => entity.id !== command.deviceViewEntityId,
    );
    delete draft.tabData[command.deviceViewEntityId];
    if (
      draft.deviceViewWindows.some(
        (win) => win.id === command.deviceViewEntityId,
      )
    ) {
      draft.deviceViewWindows = draft.deviceViewWindows.filter(
        (win) => win.id !== command.deviceViewEntityId,
      );
    }
    const detachedDeviceViewEntitiesLength = draft.deviceViewWindows.length;
    const deviceViewEntitiesLength = draft.deviceViewEntities.length;
    if (deviceViewEntitiesLength === detachedDeviceViewEntitiesLength) {
      draft.deviceViewOpen = false;
    }
    if (
      !draft.deviceViewEntities.some(
        (entity) => entity.id === draft.activeDeviceViewEntityId,
      )
    ) {
      draft.activeDeviceViewEntityId = getNewActiveEntityId(
        draft.deviceViewEntities,
        draft.deviceViewWindows,
      );
    }

    if (draft.activeDeviceViewEntityId === null) {
      return undefined;
    }

    const activeDeviceViewEntity = draft.deviceViewEntities.find(
      (entity) => entity.id === draft.activeDeviceViewEntityId,
    );
    if (activeDeviceViewEntity === undefined) {
      return undefined;
    }

    if (command.deviceViewElement !== undefined) {
      cmdContext.getState().handlersContainer.handleCloseDeviceViewEntity?.({
        currentDeviceViewEntityId: command.deviceViewEntityId,
        currentDeviceViewElement: command.deviceViewElement,
        followingDeviceViewElement: activeDeviceViewEntity.deviceViewElement,
        followingDeviceViewEntityId: draft.activeDeviceViewEntityId,
      });
    }
    return undefined;
  });
};
